import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Tile } from 'foundations-components/transitional/components/Tile';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import HR from 'UIComponents/elements/HR';
import { createLinkFromDealId } from '../../../utils/urls';
import { DealSidebarCardPropertiesSection } from './DealSidebarCardPropertiesSection';
import { ForecastingDealSplitIcon } from '../../ForecastingDealSplitIcon';
import { hasDealSplit } from '../../../utils/deals';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MAX_COMPACT_CARD_TITLE_LENGTH = 52;
const truncateTextLines = string => {
  if (!string) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: string,
    children: /*#__PURE__*/_jsx(UITruncateMultiline, {
      maxChars: MAX_COMPACT_CARD_TITLE_LENGTH,
      text: string,
      Paragraph: "span"
    })
  });
};
export const DealSidebarCard = ({
  amount,
  categoryLabel,
  currencyCode,
  deal,
  dealStageLabel,
  id,
  isDealSplittingEnabled,
  name,
  nextStep,
  email,
  ownerName
}) => {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    children: /*#__PURE__*/_jsxs(Tile, {
      paddingBlock: "100",
      paddingInline: "300",
      "data-test-id": "deal-sidebar-card",
      children: [/*#__PURE__*/_jsxs(Flex, {
        "data-selenium-test": "preview-header",
        flexDirection: "column",
        paddingBlockStart: "100",
        children: [categoryLabel && /*#__PURE__*/_jsx(Text, {
          as: "small",
          textTransform: "uppercase",
          typography: "heading-25",
          children: categoryLabel
        }), /*#__PURE__*/_jsxs(UIButton, {
          href: createLinkFromDealId(id),
          use: "link",
          external: true,
          children: [truncateTextLines(name), ' ', hasDealSplit(deal, isDealSplittingEnabled) && /*#__PURE__*/_jsx(ForecastingDealSplitIcon, {})]
        })]
      }), /*#__PURE__*/_jsx(DealSidebarCardPropertiesSection, {
        amount: amount,
        currencyCode: currencyCode,
        deal: deal,
        dealStageLabel: dealStageLabel,
        email: email,
        ownerName: ownerName
      }), nextStep && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "extra-small"
        }), /*#__PURE__*/_jsx(BreakString, {
          hyphenate: false,
          children: /*#__PURE__*/_jsxs("span", {
            children: [' ', /*#__PURE__*/_jsxs("b", {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "dealSidebar.card.nextStep"
              }), " :"]
            }), ' ', nextStep]
          })
        })]
      })]
    })
  });
};